export default __webpack_public_path__ + "static/media/plan.bdf6b711.svg";